import { render, staticRenderFns } from "./TryChips.vue?vue&type=template&id=2b208efe&scoped=true"
import script from "./TryChips.vue?vue&type=script&lang=js"
export * from "./TryChips.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b208efe",
  null
  
)

export default component.exports